import * as Actions from '../../actions';

const initialState = { data: null };

const routeRouteSessionsReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_ROUTE_ROUTE_SESSIONS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default routeRouteSessionsReducer;
